export const playNotificationSound = () => {
  try {
    // Try to play mp3 from root if present (place notify.mp3 in public/)
    const audio = new Audio('/notify.mp3');
    audio.volume = 1.0;
    audio.play().catch(() => {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const makeBeep = (freq, start, duration, volume) => {
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.type = 'square';
        o.frequency.setValueAtTime(freq, start);
        g.gain.setValueAtTime(0.0001, start);
        g.gain.exponentialRampToValueAtTime(volume, start + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, start + duration);
        o.connect(g);
        g.connect(ctx.destination);
        o.start(start);
        o.stop(start + duration + 0.02);
      };
      const now = ctx.currentTime;
      makeBeep(900, now, 0.6, 0.6);
      makeBeep(650, now + 0.65, 0.6, 0.6);
    });
  } catch (_) {
    try {
      const audio = new Audio(
        'data:audio/wav;base64,UklGRmIAAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'
      );
      audio.volume = 1.0;
      audio.play().catch(() => {});
    } catch (_) {}
  }
};
